import React from 'react';

interface DangerIconProps {
  /**
   * Icon color, defaults to currentColor
   */
  fill?: string;
  /**
   * Icon width
   */
  width?: number;
  /**
   * Icon height
   */
  height?: number;
  /**
   * CSS className
   */
  className?: string;
}

const DangerIcon: React.FC<DangerIconProps> = ({
  fill = 'currentColor',
  width = 24,
  height = 24,
  className = '',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
    >
      <title>Danger Icon</title>
      <polygon points="7,2 17,2 22,7 22,17 17,22 7,22 2,17 2,7" fill={fill} />
      <path
        d="M15 9L9 15M9 9L15 15"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DangerIcon;
